<template>
    <!-- Schedule Demo Modal -->
    <div class="modal fade" :id="modalId" tabindex="-1" aria-labelledby="schedule-demo-modal-label" aria-hidden="true" ref="demoModalRef">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header border-bottom-0 pb-0">
                    <div class="text-center w-100">
                        <button type="button" class="btn btn-white float-end close-modal" data-bs-dismiss="modal" data-bs-toggle="tooltip" title="Close">
                            <img class="icon" src="/img/icons/avid-icons/close.svg" alt="">
                        </button>
                        <h3 class="mt-2">Schedule a Demo</h3>
                    </div>
                </div>
                <div class="modal-body">
                    <div :id="formContainerId" class="hubspot-demo-form-wrapper"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, computed } from 'vue';

export default defineComponent({
    name: 'ScheduleDemoModal',
    props: {
        user: {
            type: [Object, null],
            default: null
        },
        client: {
            type: [Object, null],
            default: null
        },
        instanceId: {
            type: String,
            default: () => 'demo-' + Math.random().toString(36).slice(2, 9)
        }
    },
    setup(props) {
        const demoModalRef = ref(null);
        const modalId = computed(() => 'schedule-demo-modal-' + props.instanceId);
        const formContainerId = computed(() => 'hubspot-demo-form-' + props.instanceId);

        return {
            demoModalRef,
            modalId,
            formContainerId
        };
    },
    data() {
        return {
            hubspotFormCreated: false
        };
    },
    methods: {
        openModal() {
            const modalElement = (this.demoModalRef && this.demoModalRef.value) || document.getElementById(this.modalId);
            if (modalElement && window.bootstrap) {
                const modal = new window.bootstrap.Modal(modalElement);
                modal.show();

                const onShown = () => {
                    this.$nextTick(() => {
                        if (!this.hubspotFormCreated) {
                            this.embedHubspotForm();
                        }
                    });
                    modalElement.removeEventListener('shown.bs.modal', onShown);
                };
                modalElement.addEventListener('shown.bs.modal', onShown);
            }
        },
        loadHubspotScript() {
            return new Promise((resolve) => {
                if (window.hbspt && window.hbspt.forms) {
                    resolve();
                    return;
                }
                const script = document.createElement('script');
                script.src = '//js.hsforms.net/forms/embed/v2.js';
                script.charset = 'utf-8';
                script.async = true;
                script.onload = () => resolve();
                document.head.appendChild(script);
            });
        },
        embedHubspotForm() {
            this.loadHubspotScript().then(() => {
                const user = this.user || {};
                const client = this.client || {};
                const prefill = {
                    firstname: user.first_name || '',
                    lastname: user.last_name || '',
                    email: user.email || '',
                    company: client.name || ''
                };

                window.hbspt.forms.create({
                    portalId: '45844769',
                    formId: '823004a1-144f-46d0-9e36-a02313ed4184',
                    region: 'na1',
                    target: '#' + this.formContainerId,
                    fields: [
                        { name: 'firstname', value: prefill.firstname },
                        { name: 'lastname', value: prefill.lastname },
                        { name: 'email', value: prefill.email },
                        { name: 'company', value: prefill.company }
                    ],
                    onFormReady: (formEl) => {
                        const form = formEl && (formEl[0] || formEl);
                        if (!form || typeof form.querySelector !== 'function') return;
                        ['firstname', 'lastname', 'email', 'company'].forEach((name) => {
                            const input = form.querySelector(`input[name="${name}"]`);
                            if (input && prefill[name]) {
                                input.value = prefill[name];
                                input.dispatchEvent(new Event('input', { bubbles: true }));
                            }
                        });
                    }
                });
                this.hubspotFormCreated = true;
            });
        }
    }
});
</script>

<style scoped>
.hubspot-demo-form-wrapper :deep(.hs-form-field:has(input[name="firstname"])),
.hubspot-demo-form-wrapper :deep(.hs-form-field:has(input[name="lastname"])),
.hubspot-demo-form-wrapper :deep(.hs-form-field:has(input[name="email"])),
.hubspot-demo-form-wrapper :deep(.hs-form-field:has(input[name="company"])) {
    display: none !important;
}
</style>
